import React from  'react'
import LoginForm from '../../../smart/forms/login/LoginForm'
import '../Form.sass'

const LoginPage = () => <LoginForm />

export default LoginPage